import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../hooks";
import {
  CURRENT_WATTYS_YEAR,
  DEFAULT_MILESTONES_LINK,
  MAP_MILESTONES_LINKS
} from "../ContestForm/constants";

const CompleteEligibleBanner = ({ onBtnClick }) => {
  const { trans } = useTrans();
  const milestonesLink =
    MAP_MILESTONES_LINKS[parseInt(app.get("language"), 10)] ||
    DEFAULT_MILESTONES_LINK;

  return (
    <>
      <div className="text">
        {/* prettier-ignore */ trans("Congratulations! Your story is eligible for The %s Wattys!", CURRENT_WATTYS_YEAR)}
        <a
          className="plain-link bold"
          href={milestonesLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {trans("Find out more about the Wattys")}
        </a>
      </div>
      <button onClick={onBtnClick} className="btn btn-white">
        <div className="btn-text">{trans("Enter this story")}</div>
      </button>
    </>
  );
};

CompleteEligibleBanner.propTypes = {
  onBtnClick: PropTypes.func.isRequired
};

export default CompleteEligibleBanner;
